import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Overline, Reveal } from "./Primitives";
import { useT } from "@/lib/i18n";

export const About = () => {
  const t = useT().about;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="about" ref={ref} className="py-24 md:py-40">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid md:grid-cols-12 gap-12 md:gap-10 items-center">
        <Reveal className="md:col-span-5 order-2 md:order-1">
          <div className="relative aspect-[3/4] overflow-hidden rounded-[24px] bg-[#1c1917]" data-testid="about-image">
            <motion.img src="/lene.jpg" alt="Lene Mauro" style={{ y, scale: 1.3 }}
              className="absolute inset-0 w-full h-full object-cover object-[50%_35%] grayscale contrast-110" />
            <div className="absolute inset-0 bg-[var(--gold)] mix-blend-color opacity-20" />
            <span className="absolute top-5 left-5 font-mono text-[11px] tracking-[0.2em] uppercase bg-[#0c0a09]/70 backdrop-blur px-3 py-1.5 rounded-full">Lene Mauro</span>
          </div>
        </Reveal>
        <div className="md:col-span-7 md:pl-10 order-1 md:order-2">
          <Overline>{t.over}</Overline>
          <h2 className="mt-8 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="about-title">
            <MaskLines lines={t.title} italicIndex={1} inView />
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-10 text-base md:text-lg text-stone-300 leading-relaxed max-w-xl">{t.p1}</p>
            <p className="mt-5 text-base md:text-lg text-stone-400 leading-relaxed max-w-xl">{t.p2}</p>
            <p className="mt-10 font-display italic text-3xl text-[var(--gold)]">{t.sign}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
